<template>
  <BButton
    v-if="show === true"
    variant="danger"
    @click="handleSignout"
    :disabled="signingOut"
  >
    <span
      v-if="signingOut"
      class="spinner-border spinner-border-sm me-2"
      role="status"
      aria-hidden="true"
    ></span>
    {{ signingOut ? "Signing out..." : "Sign out" }}
  </BButton>
</template>
<script>
// Import Bootstrap Vue Next components
import { BButton } from "bootstrap-vue-next";

// Import Vuex store namespaces
import { userSession as userSessionNS } from "@/store/namespaces.js";

export default {
  name: "SignOutButton",
  components: {
    BButton,
  },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    signingOut() {
      return this.$store.getters[`${userSessionNS}/getSigningOut`];
    },
  },
  methods: {
    async handleSignout() {
      try {
        await this.$store.dispatch(`${userSessionNS}/deactivateUserSession`);
      } catch (error) {
        this.$notify.notifyError(
          "Unable to deactivate user session. Please try again."
        );
      }
    },
  },
};
</script>
